var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventChannel } from '../event';
import { getMetadata } from '../libs';
import { META } from './const';
import { SylController } from './controller';
import { SchemaMeta } from './schema';
import { getSchemaType } from './utils';
// process SylPlugin.Schema, sort out `NodeView`, `Schema instance`, and node definition (`meta`)
var schemaMetaFactory = function (Schema, adapter, props) {
    var type = getSchemaType(Schema);
    !type && console.error('has no type of', Schema.name);
    var $schema = new Schema(adapter, props);
    var meta = new SchemaMeta(type, $schema.name, $schema);
    return {
        view: $schema.NodeView || null,
        schema: $schema,
        // Deprecated getMetadata will be remove in the future
        meta: getMetadata(META, Schema) ? getMetadata(META, Schema) : meta,
    };
};
var SylPlugin = /** @class */ (function () {
    function SylPlugin(props) {
        var _this = this;
        this.name = '';
        this.$controller = null;
        this.$schema = null;
        this.$schemaMeta = null;
        this.$NodeView = null;
        this.Controller = SylController;
        this.asyncController = null;
        this.Schema = null;
        this.editor = null;
        this.props = null;
        this.controllerUnmountEvent = function () { };
        this.handleAsyncController = function () { return __awaiter(_this, void 0, void 0, function () {
            var Controller;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.asyncController || !this.editor)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.asyncController()];
                    case 1:
                        Controller = _a.sent();
                        this.editor.configurator.registerController(this.name, Controller);
                        return [2 /*return*/];
                }
            });
        }); };
        this.registerController = function (Constructor, props) {
            if (Constructor === void 0) { Constructor = _this.Controller; }
            if (!_this.editor)
                return;
            _this.Controller = Constructor;
            _this.$controller = new Constructor(_this.editor, props || _this.props || {});
            if (!_this.$controller.name)
                _this.$controller.name = _this.name;
            _this.controllerUnmountEvent = _this.$controller.editorWillUnmount.bind(_this.$controller);
            _this.editor.on(EventChannel.LocalEvent.EDITOR_WILL_UNMOUNT, _this.controllerUnmountEvent);
        };
        this.unregisterController = function () {
            if (!_this.editor || !_this.$controller)
                return;
            _this.editor.off(EventChannel.LocalEvent.EDITOR_WILL_UNMOUNT, _this.controllerUnmountEvent);
            _this.controllerUnmountEvent = function () { };
            _this.$controller = null;
        };
        if (props) {
            this.props = props;
        }
    }
    SylPlugin.getName = function () {
        return new this().name;
    };
    SylPlugin.prototype.init = function (editor, options) {
        this.editor = editor;
        this.props = __assign(__assign({}, this.props), options.controllerProps);
        if (this.Controller)
            this.registerController(this.Controller, this.props);
        if (this.asyncController)
            this.handleAsyncController();
        if (this.Schema) {
            var _a = schemaMetaFactory(this.Schema, this.editor, this.props), view = _a.view, schema = _a.schema, meta = _a.meta;
            this.$schema = schema;
            this.$NodeView = view;
            if (this.$NodeView) {
                if (options.layers)
                    this.$schema.layers = options.layers;
            }
            this.$schemaMeta = meta;
        }
    };
    return SylPlugin;
}());
var SylUnionPlugin = /** @class */ (function () {
    function SylUnionPlugin(props) {
        this.name = '';
        this.props = null;
        if (props) {
            this.props = props;
        }
    }
    SylUnionPlugin.getName = function () {
        return new this().name;
    };
    SylUnionPlugin.prototype.install = function (editor, props) {
        return this.init(editor, __assign(__assign({}, this.props), props));
    };
    SylUnionPlugin.prototype.init = function (editor, props) {
        return {};
    };
    return SylUnionPlugin;
}());
export { SylPlugin, SylUnionPlugin };
//# sourceMappingURL=plugin.js.map